import axios from 'axios'

const configJsInstance = axios.create({
	baseURL: '',
})

export default configJsInstance
